import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import { ActionButtonSecondary, Backdrop } from '../../components/Themed.js';
import { setHasChildren } from '../../data/client/ClientActions.js';
import {
  getIsFamilyMemberAccount,
  getFamilyMemberTerm,
  getIsServiceAvailableForClient,
} from '../../data/app/AppReducer.js';
import './WhoIsCheckingIn.css';
import { t } from '../../locales';

class WhoIsCheckingIn extends React.Component {
  constructor(props) {
    super(props);

    this.checkinClick = this.checkinClick.bind(this);
  }

  checkinClick(hasChildren, hasServicesForClient) {
    const { setHasChildren, history } = this.props;

    setHasChildren(hasChildren, hasServicesForClient);
    history.push('/clientForm');
  }

  render() {
    const {
      companyName,
      isFamilyMemberAccount,
      familyMemberTerm,
      isServiceAvailableForClient,
      mustSelectChild,
    } = this.props;

    if (!isFamilyMemberAccount) {
      return <Redirect to="/clientForm" />;
    }

    if (!isServiceAvailableForClient) {
      return <Redirect to="/clientForm" />;
    }

    return (
      <React.Fragment>
        <Backdrop id="backdrop" />
        <div className="scroll-container content-container">
          <div className="page-container">
            <div className="return-client">
              <div className="who-is-checking-in-title">
                {t('who_is_checking_in.welcome_to')} {companyName}!
                <br />
                {t('who_is_checking_in.who_is_checking-in_today')}
              </div>
              <div className="content-medium">
                {isServiceAvailableForClient && !mustSelectChild && (
                  <ActionButtonSecondary
                    onClick={() => this.checkinClick(false, true)}
                  >
                    {t('who_is_checking_in.check_in_myself')}
                  </ActionButtonSecondary>
                )}
                {isFamilyMemberAccount && (
                  <ActionButtonSecondary
                    onClick={() => this.checkinClick(true, false)}
                  >
                    {t('who_is_checking_in.check_in')} {familyMemberTerm}
                  </ActionButtonSecondary>
                )}
                {isFamilyMemberAccount && !mustSelectChild && isServiceAvailableForClient && (
                  <ActionButtonSecondary
                    onClick={() => this.checkinClick(true, true)}
                  >
                    {t('who_is_checking_in.check_in_both')}
                  </ActionButtonSecondary>
                )}
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    isNewClient: state.client.isNewClient,
    companyName: state.app.businessInfo.company.name,
    isFamilyMemberAccount: getIsFamilyMemberAccount(state.app.businessInfo),
    familyMemberTerm: getFamilyMemberTerm(state.app.businessInfo),
    isServiceAvailableForClient: getIsServiceAvailableForClient(
      state.app.businessInfo
    ),
    mustSelectChild: state.app.businessInfo.company.must_select_child,
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    { setHasChildren }
  )(WhoIsCheckingIn)
);
